import TOKEN_INFO from "paymentTokenABIs/ERC20.json";

export const NFT_ADDRESS = "0x42c127dc287881274982d8Ec45a15016D89b5E79"; // "0xA96E7654330f2C8cF1acD07d3600BAeD6Bf7a417";
export const NFT_MARKET_ADDRESS = "0x57fbce77A24E3866E7094645c49D8fFC7Ffa5370"; // "0x433403C379b041cC622db6E0d37aa2eFD89a5456";

export const NFTStorageKey =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJkaWQ6ZXRocjoweEFkYzY2NDdCRTc4MDMzMGU2YzExMzA3NkFhQTM3RjQ1OTk0ODU3N0EiLCJpc3MiOiJuZnQtc3RvcmFnZSIsImlhdCI6MTYzMzU3MTUxMTY0MCwibmFtZSI6Im5mdHNyZWFsbS1ic2MifQ.IcBX8f3zsMybw2UOR9xxtnJU-Hmfa6wQ-BWpqALJDCk";
export const Networks = {
  BSC: 56,
  BSCTestnet: 97,
};
export const PaymentList = [
  { name: "BNB", value: "BNB" },
  { name: "FLOKIN", value: "FLOKIN" },
];
export const DefaultNetwork = 97;
export const DefaultAvatar = "/assets/img/avatars/avatar.jpg";
export const DefaultCoverImage = "/assets/img/bg/bg.png";
export const DefaultNickName = "@user";
export const MAX_LIMIT_FOR_BNB = 200;
export const MAX_LIMIT_FOR_TOKEN = 10000;

export const PAYMENT_TOKEN = {
  PAD: {
    tokenAddress: "0x32522BF4697c78770399e38406362fd05B5A3Dd0",
    abi: TOKEN_INFO,
  },
};
